<template>
    <div>
        <table class="form-table">
            <tbody>
                <tr>
                    <td>
                        <label>{{ $t('Enable retries') }}:</label>
                    </td>
                    <td>
                        <CicCheckbox
                            id="campaign_retries"
                            :value="item.useRetries"
                            @input="(val) => updateFieldValue('useRetries', val)"
                        />
                    </td>
                </tr>
                <template v-if="item.useRetries">
                    <tr>
                        <td class="sub-option">{{ $t('Retry Profile') }}:</td>
                        <td>
                            <CicSelect
                                id="campaign_retryprofile"
                                :options="
                                    retryProfiles.map((profile) => ({
                                        value: profile.profileId,
                                        label: profile.name,
                                    }))
                                "
                                :placeholder="$t('Please select...')"
                                :value="item.retryProfileId"
                                @input="(val) => updateFieldValue('retryProfileId', val)"
                            />
                        </td>
                    </tr>
                    <tr v-if="retryScript">
                        <td class="sub-option">{{ $t('Use a Different Service') }}:</td>
                        <td>
                            <CicCheckbox
                                id="campaign_retrydiff"
                                :value="item.useRetryScript"
                                @input="(val) => updateFieldValue('useRetryScript', val)"
                            />
                        </td>
                    </tr>
                    <tr v-if="retryScript && item.useRetryScript">
                        <td class="sub-option">{{ $t('Service') }}:</td>
                        <td>
                            <CicSelect
                                id="campaign_retryscript"
                                :options="
                                    scripts.map((script) => ({
                                        value: script.scriptId,
                                        label: script.name,
                                    }))
                                "
                                :placeholder="$t('Please select...')"
                                :value="item.retryScriptId"
                                @input="(val) => updateFieldValue('retryScriptId', val)"
                            />
                        </td>
                    </tr>
                    <tr v-if="batchPrioritisation">
                        <td class="sub-option" style="vertical-align: top">{{ $t('Processing Rules') }}:</td>
                        <td>
                            <CicRadioGroup
                                id="campaign_prioritisation"
                                :options="[
                                    { value: 0, label: $t('Prioritise Retries') },
                                    { value: 1, label: $t('Prioritise Unprocessed Records') },
                                    { value: 2, label: $t('Use a Percentage Split') },
                                ]"
                                :value="item.prioritisation"
                                class="vertical"
                                @input="(val) => updateFieldValue('prioritisation', val)"
                            />
                        </td>
                    </tr>
                    <template v-if="item.prioritisation === 2">
                        <tr>
                            <td class="sub-option">{{ $t('Unprocessed Records') }}:</td>
                            <td>
                                <CicTextbox
                                    id="campaign_unprocessedpercent"
                                    :value="item.unprocessedPercentage"
                                    int-only
                                    maxlength="3"
                                    @input="updateUnprocessed"
                                />
                                <span style="padding-left: 5px">{{ $t('%') }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="sub-option">{{ $t('Retries') }}:</td>
                            <td>
                                <CicTextbox
                                    id="campaign_retrypercent"
                                    :value="item.retryPercentage"
                                    int-only
                                    maxlength="3"
                                    @input="updatePercentage"
                                />
                                <span style="padding-left: 5px">{{ $t('%') }}</span>
                            </td>
                        </tr>
                    </template>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicRadioGroup from '@/components/inputs/CicRadioGroup';
    import CicSelect from '@/components/inputs/CicSelect';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'EditRetries',
        components: {
            CicCheckbox,
            CicRadioGroup,
            CicSelect,
            CicTextbox,
        },
        props: {
            batchPrioritisation: {
                type: Boolean,
                default: false,
            },
            item: {
                type: Object,
                required: true,
            },
            retryProfiles: {
                type: Array,
                required: true,
            },
            retryScript: {
                type: Boolean,
                default: false,
            },
            scripts: {
                type: Array,
                required: true,
            },
        },
        emits: ['change'],
        methods: {
            updateFieldValue(name, value) {
                this.$emit('change', name, value);
            },
            updatePercentage(value) {
                this.updateFieldValue('retryPercentage', value);
                this.updateFieldValue('unprocessedPercentage', value !== '' ? 100 - parseInt(value) : '');
            },
            updateUnprocessed(value) {
                this.updateFieldValue('unprocessedPercentage', value);
                this.updateFieldValue('retryPercentage', value !== '' ? 100 - parseInt(value) : '');
            },
        },
    };
</script>
